/**
 * Motion tokens — durations and interaction feedback.
 *
 * WI-3 §2 defines exactly five interaction "moments" — hover, press, focus,
 * loading, live pulse — each with one token. Nothing else animates. All are
 * CSS/Tailwind only (no framer-motion) and covered by the
 * `prefers-reduced-motion` block in `animations.css`.
 */
export const motion = {
  transition: 'transition-all',
  duration: {
    fast: 'duration-200',
    normal: 'duration-300',
    slow: 'duration-500',
  },
  /** Press: tap feedback on primary controls */
  activeScale: 'active:scale-[0.98]',
  /** Hover: subtle lift on interactive cards (desktop only, motion-safe). Pair with `transition` + `duration.fast`. */
  hover: 'motion-safe:md:hover:-translate-y-0.5',
  /** Focus: focus-visible ring scaffold; the control supplies the accent ring color (e.g. `ring-emerald-300/70`). */
  focusRing: 'focus-visible:outline-none focus-visible:ring-2',
  /** Loading: skeleton shimmer. */
  pulse: 'animate-pulse',
  /** Live: status-dot breathing pulse on live indicators. */
  livePulse: 'animate-pulse',
  /** Desktop modal enter (mobile skips transform — iOS input focus) */
  modalEnter: 'max-md:transform-none md:animate-in md:fade-in md:zoom-in-95 md:duration-300',
  /** Section reveal on home shell */
  fadeInUp: 'animate-in fade-in slide-in-from-bottom-2 duration-500',
};
